import parkingImage from '../../assets/images/360Images/1.webp';
import arrivalCourtImage from '../../assets/images/360Images/2.webp';
import cocktailPavilionImage from '../../assets/images/360Images/3.webp';
import grandVistaTerraceImage from '../../assets/images/360Images/4.webp';
import sunsetCeremonyLawnImage from '../../assets/images/360Images/5.webp';
import grandBallroomImage from '../../assets/images/360Images/6.webp';
import decoratedGrandBallroomImage from '../../assets/images/360Images/6-decorated.webp';
import bridalVillaImage from '../../assets/images/360Images/7.webp';
import gentlemansLoungeImage from '../../assets/images/360Images/8.webp';
import signatureBarImage from '../../assets/images/360Images/9.webp';
import decoratedSignatureBarImage from '../../assets/images/360Images/9-decorated.webp';

import * as THREE from 'three';

export const AUTO_ROTATE_SCENE_INDICES = [];
export const AUTO_ROTATE_SPEED = 2;
export const AUTO_ROTATE_ANGLE_RANGES = {};

const SCENES = [
  { panoImage: parkingImage, name: 'Parking' },
  { panoImage: arrivalCourtImage, name: 'The Arrival Court' },
  { panoImage: cocktailPavilionImage, name: 'The Cocktail Pavilion' },
  { panoImage: grandVistaTerraceImage, name: 'The Grand Vista Terrace' },
  { panoImage: sunsetCeremonyLawnImage, name: 'The Sunset Ceremony Lawn' },
  {
    panoImage: new URLSearchParams(window.location.search).get('decor') === 'original'
      ? grandBallroomImage
      : decoratedGrandBallroomImage,
    name: 'The Grand Ballroom',
  },
  { panoImage: bridalVillaImage, name: 'The Bridal Villa' },
  { panoImage: gentlemansLoungeImage, name: "The Gentleman's Lounge" },
  {
    panoImage: new URLSearchParams(window.location.search).get('decor') === 'original'
      ? signatureBarImage
      : decoratedSignatureBarImage,
    name: 'The Signature Bar',
  },
];

const HOTSPOT_SCALE = new THREE.Vector3(3, 3, 1);
const HOTSPOT_ROTATION = new THREE.Vector3(0, 0, 0);

const panoViews = [
  {
    panoImage: SCENES[0].panoImage,
    name: SCENES[0].name,
    initialRotation: [90, 0],
    initialRotationMobile: [90, 0],
    infoSpots: [],
    links: [
     
      {
        name: SCENES[1].name, // The Arrival Court
        hotspotRoom: SCENES[1].name, // The Arrival Court
        linkTo: 1,
        position: new THREE.Vector3(-220, -20,20),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
    ],
  },
  {
    panoImage: SCENES[1].panoImage,
    name: SCENES[1].name,
    initialRotation: [220, 0],
    initialRotationMobile: [220, 0],
    infoSpots: [],
    links: [
      {
        name: SCENES[0].name, // Parking
        hotspotRoom: SCENES[0].name, // Parking
        linkTo: 0,
        position: new THREE.Vector3(-220, -20,-160),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
      {
        name: SCENES[3].name, // The Grand Vista Terrace
        hotspotRoom: SCENES[3].name, // The Grand Vista Terrace
        linkTo: 3,
        position: new THREE.Vector3(130, -20, 220),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
      {
        name: SCENES[5].name, // The Grand Ballroom
        hotspotRoom: SCENES[5].name, // The Grand Ballroom
        linkTo: 5,
        position: new THREE.Vector3(220, -20, 20),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
      {
        name: SCENES[2].name, // The Cocktail Pavilion
        hotspotRoom: SCENES[2].name, // The Cocktail Pavilion
        linkTo: 2,
        position: new THREE.Vector3(-70, -20, 220),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
    ],
  },
  {
    panoImage: SCENES[2].panoImage,
    name: SCENES[2].name,
    initialRotation: [270, 0],
    initialRotationMobile: [270, 0],
    infoSpots: [],
    links: [
      {
        name: SCENES[1].name, // The Arrival Court
        hotspotRoom: SCENES[1].name, // The Arrival Court
        linkTo: 1,
        position: new THREE.Vector3(-220, 10,160),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
      {
        name: SCENES[3].name, // The Grand Vista Terrace
        hotspotRoom: SCENES[3].name, // The Grand Vista Terrace
        linkTo: 3,
        position: new THREE.Vector3(-220, 10, -70),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
      {
        name: SCENES[4].name, // The Sunset Ceremony Lawn
        hotspotRoom: SCENES[4].name, // The Sunset Ceremony Lawn
        linkTo: 4,
        position: new THREE.Vector3(-120, -20, -160),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
    ],
  },
  {
    panoImage: SCENES[3].panoImage,
    name: SCENES[3].name,
    initialRotation: [90, 0],
    initialRotationMobile: [90, 0],
    infoSpots: [],
    links: [
     
      {
        name: SCENES[4].name, // The Sunset Ceremony Lawn
        hotspotRoom: SCENES[4].name, // The Sunset Ceremony Lawn
        linkTo: 4,
        position: new THREE.Vector3(220, -90, 120),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
      {
        name: SCENES[1].name, // The Arrival Court
        hotspotRoom: SCENES[1].name, // The Arrival Court
        linkTo: 1,
        position: new THREE.Vector3(-100, -20, 220),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
      {
        name: SCENES[8].name, // The Signature Bar
        hotspotRoom: SCENES[8].name, // The Signature Bar
        linkTo: 8,
        position: new THREE.Vector3(-220, -20, 20),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
    ],
  },
  {
    panoImage: SCENES[4].panoImage,
    name: SCENES[4].name,
    initialRotation: [90, 0],
    initialRotationMobile: [90, 0],
    infoSpots: [],
    links: [
      {
        name: SCENES[3].name, // The Grand Vista Terrace
        hotspotRoom: SCENES[3].name, // The Grand Vista Terrace
        linkTo: 3,
        position: new THREE.Vector3(40, 20, -220),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
      {
        name: SCENES[1].name, // The Arrival Court
        hotspotRoom: SCENES[1].name, // The Arrival Court
        linkTo: 1,
        position: new THREE.Vector3(-220, -10, -120),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
      {
        name: SCENES[2].name, // The Cocktail Pavilion
        hotspotRoom: SCENES[2].name, // The Cocktail Pavilion
        linkTo: 2,
        position: new THREE.Vector3(-220, -20, 20),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
    ],
  },
  {
    panoImage: SCENES[5].panoImage,
    name: SCENES[5].name,
    initialRotation: [90, 0],
    initialRotationMobile: [90, 0],
    infoSpots: [],
    links: [
      {
        name: SCENES[6].name, // The Bridal Villa
        hotspotRoom: SCENES[6].name, // The Bridal Villa
        linkTo: 6,
        position: new THREE.Vector3(-100, -30, -120),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
      {
        name: SCENES[7].name, // The Gentleman's Lounge
        hotspotRoom: SCENES[7].name, // The Gentleman's Lounge
        linkTo: 7,
        position: new THREE.Vector3(-130, -30, 120),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
      {
        name: SCENES[1].name, // The Arrival Court
        hotspotRoom: SCENES[1].name, // The Arrival Court
        linkTo: 1,
        position: new THREE.Vector3(220, -40,0),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
      {
        name: SCENES[8].name, // The Signature Bar
        hotspotRoom: SCENES[8].name, // The Signature Bar
        linkTo: 8,
        position: new THREE.Vector3(-220, -20, -20),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
    ],
  },
  {
    panoImage: SCENES[6].panoImage,
    name: SCENES[6].name,
    initialRotation: [90, 0],
    initialRotationMobile: [90, 0],
    infoSpots: [],
    links: [
      {
        name: SCENES[5].name, // The Grand Ballroom
        hotspotRoom: SCENES[5].name, // The Grand Ballroom
        linkTo: 5,
        position: new THREE.Vector3(-190, -30, 220),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
    
    ],
  },
  {
    panoImage: SCENES[7].panoImage,
    name: SCENES[7].name,
    initialRotation: [90, 0],
    initialRotationMobile: [90, 0],
    infoSpots: [],
    links: [
      {
        name: SCENES[5].name, // The Grand Ballroom
        hotspotRoom: SCENES[5].name, // The Grand Ballroom
        linkTo: 5,
        position: new THREE.Vector3(-30, -30,-120),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
     
    ],
  },
  {
    panoImage: SCENES[8].panoImage,
    name: SCENES[8].name,
    initialRotation: [90, 0],
    initialRotationMobile: [90, 0],
    infoSpots: [],
    links: [
      {
        name: SCENES[5].name, // The Grand Ballroom
        hotspotRoom: SCENES[5].name, // The Grand Ballroom
        linkTo: 5,
        position: new THREE.Vector3(220, -30,0),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
      {
        name: SCENES[3].name, // The Grand Vista Terrace
        hotspotRoom: SCENES[3].name, // The Grand Vista Terrace
        linkTo: 3,
        position: new THREE.Vector3(-70, -30, -120),
        scale: HOTSPOT_SCALE.clone(),
        rotation: HOTSPOT_ROTATION.clone(),
      },
    ],
  },
];

export default panoViews;
